import * as React from 'react';

import { useShouldRenderBanner } from './utils/useShouldRenderBanner';
import { RealtorBannerCard } from '../../components/RealtorBannerCard';
import { useDeviceType } from '@cian/ui-kit/responsive';
import { trackClickBanner } from './tracking';
import { BANNER_URL } from './constants';

interface IRealtorBannerContainerProps {
  currentIndex: number;
  listLength: number;
  isLast?: boolean;
}

export const RealtorBannerContainer: React.FC<IRealtorBannerContainerProps> = props => {
  const { listLength, isLast, currentIndex } = props;
  const deviceType = useDeviceType();
  const handleClickBanner = React.useCallback(() => trackClickBanner(deviceType), [deviceType]);

  const shouldRenderBanner = useShouldRenderBanner(listLength);

  if (!shouldRenderBanner(currentIndex, isLast)) {
    return null;
  }

  return <RealtorBannerCard url={BANNER_URL} onClick={handleClickBanner} />;
};

RealtorBannerContainer.displayName = 'RealtorBannerContainer';
